@if (activeItem()) {
    <p-tabs [(value)]="activeItem">
        <p-tablist>
            @for (tab of tabs; track tab.route) {
                <p-tab [value]="tab.route">
                    <i [class]="tab.icon"></i>
                    <span class="hidden sm:block">{{ tab.label | translate }}</span>
                </p-tab>
            }
        </p-tablist>
    </p-tabs>
}
